// extracted by mini-css-extract-plugin
export default {"container":"Blog_container__FX2Al","title":"Blog_title__AkIza","text":"Blog_text__GZ5+g","image":"Blog_image__JOfj5","blogHR":"Blog_blogHR__xf-4+"};